/**
 * Characters that are dangerous in HTML/JS contexts.
 * These must not appear in the decoded query string.
 */
const DANGEROUS_CHARS_PATTERN = /[<>"'`]/;

/**
 * Regular expression pattern for valid URL slugs.
 * Allows only lowercase letters, numbers, and hyphens.
 * Cannot start or end with a hyphen.
 */
const VALID_SLUG_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;

/**
 * Regular expression pattern for valid URL pathnames (decoded).
 * Allows lowercase letters, numbers, hyphens, and forward slashes.
 * Path segments cannot start or end with hyphens.
 */
const VALID_PATHNAME_PATTERN = /^(\/[a-z0-9]+(-[a-z0-9]+)*)+\/?$|^\/$/;

/**
 * Valid query string pattern (decoded).
 * Allows: ?, &, =, alphanumeric, hyphens, underscores, periods, plus signs.
 * Does not allow HTML special characters or control characters.
 */
const VALID_SEARCH_PATTERN = /^(\?[a-zA-Z0-9\-_.+=&]*)?$/;
export function isValidSlug(slug) {
  if (!slug || typeof slug !== 'string') {
    return false;
  }

  // First decode to check for hidden dangerous chars
  let decodedSlug;
  try {
    decodedSlug = decodeURIComponent(slug);
  } catch (_unused) {
    return false;
  }

  // Validate against allowed pattern (decoded version)
  return VALID_SLUG_PATTERN.test(decodedSlug);
}
export function sanitizeUrlSlug(slug) {
  if (!slug || typeof slug !== 'string') {
    return '';
  }
  let decodedSlug;
  try {
    decodedSlug = decodeURIComponent(slug);
  } catch (_unused2) {
    return '';
  }
  if (!VALID_SLUG_PATTERN.test(decodedSlug)) {
    return '';
  }
  return slug;
}
export function sanitizeUrlPathname(pathname) {
  if (!pathname || typeof pathname !== 'string') {
    return '';
  }
  let decodedPathname;
  try {
    decodedPathname = decodeURIComponent(pathname);
  } catch (_unused3) {
    return '';
  }
  if (!VALID_PATHNAME_PATTERN.test(decodedPathname)) {
    return '';
  }
  return pathname;
}
export function sanitizeUrlSearch(search) {
  if (!search || typeof search !== 'string') {
    return '';
  }
  let decodedSearch;
  try {
    decodedSearch = decodeURIComponent(search);
  } catch (_unused4) {
    return '';
  }
  if (DANGEROUS_CHARS_PATTERN.test(decodedSearch)) {
    return '';
  }
  if (!VALID_SEARCH_PATTERN.test(decodedSearch)) {
    return '';
  }
  return search;
}